import React from 'react';
import './EscapeHatch.scss';
import { HeroTiles, ViewBanner } from '../../../components/sections';
import { useHelpCardsContent } from '../../../views/page-not-found-view/hooks/use-help-cards-content';
import { useSearchContent } from '../../../components/sections/search-bar/hooks/use-search-content';
const EscapeHatch = () => {
    const helpCardsContent = useHelpCardsContent();
    const searchContent = useSearchContent();
    return (
        helpCardsContent &&
        searchContent && (
            <div className="escape-hatch">
                <ViewBanner
                    topComponent={
                        <div
                            role="region"
                            aria-labelledby="support-escape-hatch-heading"
                        >
                            <div className="support-heading-and-description">
                                <h2
                                    id="support-escape-hatch-heading"
                                    className="support-escape-hatch-heading"
                                >
                                    {helpCardsContent.escapeHatchTitle}
                                </h2>
                                <p className="support-escape-hatch-subtitle">
                                    {helpCardsContent.escapeHatchDescription}
                                </p>
                            </div>
                        </div>
                    }
                    bottomComponent={
                        <HeroTiles helpCardsContent={helpCardsContent} />
                    }
                    backgroundImageDesktop={
                        process.env.REACT_APP_AEM_BASE_URL +
                        searchContent.searchBackgroundImageDesktop
                    }
                    backgroundImageMobile={
                        process.env.REACT_APP_AEM_BASE_URL +
                        searchContent.searchBackgroundImageMobile
                    }
                    componentStyle="no-bottom"
                />
            </div>
        )
    );
};
export default EscapeHatch;
